import http from '@/plugins/axios_plugin';

class ServiceFornecedores {
    index (fornecedor_id) {
        return http.get('/api/fornecedores/config/listar?id=' + fornecedor_id)
    }

    salvarConfig (fornecedor) {
        return http.post('/api/fornecedores/config/salvar', fornecedor)
    }

    representantes (fornecedor_id) {
        return http.get('/api/fornecedores/' + fornecedor_id + '/representantes')
    }

    representantesSalvar (fornecedor, representantes) {
        return http.post('/api/fornecedores/' + fornecedor + '/representantes/salvar', representantes)
    }



    listar () {
        return http.get('/api/fornecedores/listar');
    }

    listarFiltroLoja () {
        return http.get('/api/fornecedores/listar/loja');
    }

    salvar (fornecedor) {
        return http.post('/api/fornecedores/salvar', fornecedor);
    }

    editar (fornecedor_id) {
        return http.get('/api/fornecedores/' + fornecedor_id + '/editar');
    }

    atualizar (fornecedor) {
        return http.post('/api/fornecedores/' + fornecedor.id + '/atualizar', fornecedor);
    }

    excluir (fornecedor_id) {
        return http.post('/api/fornecedores/' + fornecedor_id + '/excluir');
    }

    resetarSenha (fornecedor_id) {
        return http.post('/api/fornecedores/' + fornecedor_id + '/resetar');
    }

    bloquear (fornecedor_id) {
        return http.post('/api/fornecedores/' + fornecedor_id + '/bloquear');
    }

    listarAvaliacoes (fornecedor_id) {
        return http.get('/api/fornecedores/' + + fornecedor_id + '/listar-avaliacoes');
    }

    salvarAvaliacaoRepresentante (avaliacao) {
        return http.post('/api/fornecedores/salvar-avaliacao-representante', avaliacao);
    }

    excluirAvaliacaoRepresentante (avaliacao_id) {
        return http.post('/api/fornecedores/excluir-avaliacao-representante/' + avaliacao_id);
    }

    listarLogo(fornecedor_id) {
        return http.get('/api/fornecedores/' + fornecedor_id + '/logo/listar');
    }

    salvarLogo (fornecedor_id, logo) {
        return http.post(`/api/fornecedores/${fornecedor_id}/logo/salvar`, logo);
    }
}

export default new ServiceFornecedores();